import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';
import { Button } from '@atlas/ui';

import { getBonusActionButtons } from './bonusActionButtons';
import { useBonusActions } from './useBonusActions';

const BonusDetailHeaderActions = ({ actionGroup, isDepositLike, isFreeSpin }) => {
  const hideCancel = SiteConfigManager.getConfig('config.config.general.hideBonusCancel');

  const actions = useBonusActions();
  const buttons = getBonusActionButtons({
    actionGroup,
    actions,
    hideCancel,
    isDepositLike,
    isFreeSpin,
  });

  const [pendingKey, setPendingKey] = useState(null);
  const mountedRef = useRef(true);
  const pendingRef = useRef(false);

  useEffect(
    () => () => {
      mountedRef.current = false;
    },
    [],
  );

  // While an action is in flight, the clicked button shows a spinner and every
  // button is disabled so the request cannot be fired twice or be raced.
  const runAction = (key, onClick) => async () => {
    if (pendingRef.current) return;
    pendingRef.current = true;
    setPendingKey(key);
    try {
      await onClick?.();
    } catch {
      // Action failures surface their own notifications; just release the buttons.
    } finally {
      pendingRef.current = false;
      if (mountedRef.current) setPendingKey(null);
    }
  };

  if (buttons.length === 0) return null;

  return (
    <div className="bonus-details-action-buttons">
      {buttons.map(({ key, label, onClick, type }) => (
        <Button
          className="bonus-details__header-button"
          disabled={Boolean(pendingKey)}
          key={key}
          label={label}
          loading={pendingKey === key}
          onClick={runAction(key, onClick)}
          size="medium"
          type={type}
        />
      ))}
    </div>
  );
};

BonusDetailHeaderActions.propTypes = {
  actionGroup: PropTypes.string,
  isDepositLike: PropTypes.bool,
  isFreeSpin: PropTypes.bool,
};

export default BonusDetailHeaderActions;
